<div layout="row" layout-align="space-between center">
  <span [translate]="data?.info"
    >Warning! No enabled utilization fee.</span
  >
  <button matTooltip="{{ 'global.dismiss' | translate }}" mat-icon-button (click)="dismiss()">
    <span>ОК</span>
  </button>
</div>
